(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  // Example size logic (edit these rules to match your real sizing).
  // You can replace this with a table/lookup by height & weight ranges.
  function recommendMale(weightKg, heightCm) {
    // Basic BMI-ish + height bias (simple, not medical)
    const bmi = weightKg / Math.pow(heightCm / 100, 2);

    if (bmi < 21) return "S";
    if (bmi < 24) return "M";
    if (bmi < 27) return "L";
    if (bmi < 30) return "XL";
    return "XXL";
  }

  function recommendFemale(weightKg, heightCm) {
    const bmi = weightKg / Math.pow(heightCm / 100, 2);

    // Slightly different thresholds (example)
    if (bmi < 20) return "XS";
    if (bmi < 23) return "S";
    if (bmi < 26) return "M";
    if (bmi < 29) return "L";
    return "XL";
  }

  // Tries to select the size option in Shopify variant picker (works with many themes)
  function trySelectSize(sizeText) {
    // 1) Buttons (common in Dawn)
    const button = Array.from(document.querySelectorAll('input[type="radio"], button'))
      .find(el => (el.value || el.textContent || "").trim().toUpperCase() === sizeText.toUpperCase());

    if (button) {
      button.click();
      return true;
    }

    // 2) Select dropdown
    const selects = document.querySelectorAll('select');
    for (const s of selects) {
      const opt = Array.from(s.options).find(o => (o.text || "").trim().toUpperCase() === sizeText.toUpperCase());
      if (opt) {
        s.value = opt.value;
        s.dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function init(container) {
    const btn = container.querySelector(".sr-btn");
    const wInput = container.querySelector(".sr-weight");
    const hInput = container.querySelector(".sr-height");
    const out = container.querySelector(".sr-result");
    const gender = (container.dataset.gender || "male").toLowerCase();

    btn.addEventListener("click", function () {
      const weight = parseFloat(wInput.value);
      const height = parseFloat(hInput.value);

      if (!Number.isFinite(weight) || !Number.isFinite(height)) {
        out.textContent = "Please enter both weight and height.";
        return;
      }

      // Basic sanity clamps
      const w = clamp(weight, 30, 200);
      const h = clamp(height, 130, 220);

      const size = gender === "female" ? recommendFemale(w, h) : recommendMale(w, h);

      const picked = trySelectSize(size);
      out.textContent = picked
        ? `Recommended size: ${size} (selected for you)`
        : `Recommended size: ${size}`;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".size-recommender").forEach(init);
  });
})();
